module.exports = __webpack_public_path__ + "img/icon-map.a8ba273f.svg";